import React from 'react'
import ConnectedWebsites from './connected-websites'

// import ChangeInput from './change-input'
// import Row, { Slot } from './row'

interface Props {
  className?: string
}

export default function ConnectedWebsitesSettings({ className }: Props) {
  return (
    <div className={className}>
      <ConnectedWebsites />
    </div>
  )
}
